import React, { Component } from 'react';

import compose from 'recompose/compose';
import { DateRange } from 'react-date-range';

import { addDays, addMonths } from 'date-fns';
import { es, enUS, pt } from 'react-date-range/src/locale/index.js'

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@mui/material/Alert';
import Paper from '@material-ui/core/Paper';
// Shared components

import TextField from '@material-ui/core/TextField/index';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import moment from 'moment'
import 'moment/locale/es'
import {createMaintenance} from '../../../services/createMaintenance'
import {getValidateMaintenance} from '../../../services/getValidateMaintenance';

// Component styles
import styles from './styles';
import { withTranslation } from 'react-i18next';

const mapToShortLocale = (lng) => {
    if (!lng) return 'es'
    return (typeof lng === 'string' && lng.indexOf('-') > -1) ? lng.split('-')[0] : lng
}

const mapToDateFnsLocale = (key) => {
    switch (key) {
        case 'es': return es
        case 'pt': return pt
        case 'en':
        default:
            return enUS
    }
}
class Schedule extends Component {
    constructor(props) {
        const initialLocale = mapToShortLocale(props && props.i18n && props.i18n.language ? props.i18n.language : 'es')
        const listObjectives=(JSON.parse(sessionStorage.getItem("listaObjetivosOnline")))
        const user=(sessionStorage.getItem("user"))
        const nameUser=(sessionStorage.getItem("user_name"))
        super(props);
        var range={
            selection: {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection',
            }
        }
        var isBooleanDate = false
        if (props.dataMaintenance && Object.keys(props.dataMaintenance).length > 0){
            isBooleanDate = true
            range={
                selection: {
                    startDate: new Date(props.dataMaintenance.dateBegin),
                    endDate: new Date(props.dataMaintenance.dateEnd),
                    key: 'selection',
                }
            }
        } 
        moment.locale(initialLocale)
        
        //this.myCallback = this.myCallback.bind(this);
        this.state = {
            localeKey: initialLocale,
            dateFnsLocale: mapToDateFnsLocale(initialLocale),
            props: props,
            online:null,
            dateRange:range,
            booleanDate:isBooleanDate,
            listObjectives:listObjectives,
            nameUser:nameUser,
            user:user,
            newState: isBooleanDate ? {'begin': '2020-01-01 '+props.dataMaintenance.dateBegin.substring(11), 
                                       'final': '2020-01-01 '+props.dataMaintenance.dateEnd.substring(11), 
                                       'titulo': (props && props.t) ? props.t('schedule.defaults.title') : 'Mantenimiento', 'comment': (props && props.t) ? props.t('schedule.defaults.comment') : 'Mantenimiento', 
                                       'objetivos': [listObjectives.find(i => i.objetivo_id === Number(props.dataMaintenance.objetivo.objetivo_id))]} 
                                       : {},
            errorBegin:false,
            errorFinal:false,
            error:false,
            errors:[
              'schedule.errors.no_date',
              'schedule.errors.missing_params',
              'schedule.errors.bad_time_format',
              'schedule.errors.bad_time_range',
              'schedule.errors.no_objectives',
              'schedule.errors.end_before_start'
            ],
            loadModal:false,
            check:null,
            hourInitial: isBooleanDate ? props.dataMaintenance.dateBegin.substring(11) : '' ,
            hourFinal: isBooleanDate ? props.dataMaintenance.dateEnd.substring(11) : ''  ,
            title: isBooleanDate ? ((props && props.t) ? props.t('schedule.defaults.title') : 'Mantenimiento') : ''  ,
            comment: isBooleanDate ? ((props && props.t) ? props.t('schedule.defaults.comment') : 'Mantenimiento') : ''  ,
            objId: isBooleanDate ? [listObjectives.find(i => i.objetivo_id === Number(props.dataMaintenance.objetivo.objetivo_id))] : [],
            objError: []
        }
    }

    componentDidMount() {
        if (this.props && this.props.i18n && this.props.i18n.on) {
            this.props.i18n.on('languageChanged', this._onLangChanged)
        }
    }

    componentWillUnmount() {
        if (this.props && this.props.i18n && this.props.i18n.off) {
            this.props.i18n.off('languageChanged', this._onLangChanged)
        }
    }

    _onLangChanged = (lng) => {
        const key = mapToShortLocale(lng)
        moment.locale(key)
        this.setState({ localeKey: key, dateFnsLocale: mapToDateFnsLocale(key) })
    }

    handleRangeChange(which, payload) {
        this.setState({
            [which]: {
                ...this.state[which],
                ...payload,
            },
            booleanDate:true
        });
    
        
    }
    handleFieldChange = (field, value) => {
        const {dateRange, nameUser, booleanDate,newState}=this.state
        if(typeof(value)==='object'){
            field='objetivos'
        }
        if(field==='begin'){
            value='2020-01-01 '+String(value)
            if(String(moment(value)._f)!=="YYYY-MM-DD HH:mm:ss"){
                this.setState({
                    errorBegin:true
                })
            }else{
                value=moment(value, 'YYYY-MM-DD[T]HH:mm:ss')
                this.setState({
                    errorBegin:false
                })
            }
        }
        if(field==='final'){
            value='2020-01-01 '+String(value)
            if(String(moment(value)._f)!=="YYYY-MM-DD HH:mm:ss"){
                this.setState({
                    errorFinal:true
                })
            }else{
                this.setState({
                    errorFinal:false
                })
            }
        }else{
            this.setState({
                errorFinal:false
            })
        }
        newState[field] = value;
        if(Object.keys(newState).length===5){
            this.setState({
                newState:newState
            })
        }
    };

    handleSaved = async (value) => {
        const {dateRange, nameUser, booleanDate,newState, errorBegin, errorFinal, listObjectives, user}=this.state
        const {comment, titulo, objetivos}=newState
        
        if(booleanDate===false){
            this.setState({
                error:true,
                errorIndex:0
            })
        }else if(Object.keys(newState).length!==5){
            this.setState({
                error:true,
                errorIndex:1
            })
        }else{
            var newObjetivos=(objetivos.map(ele=>ele.objetivo_id))
            var begin=(moment(dateRange.selection.startDate).format("YYYY-MM-DD")+' '+moment(newState['begin']).format("HH:mm:ss"))
            var final=(moment(dateRange.selection.endDate).format("YYYY-MM-DD")+' '+moment(newState['final']).format("HH:mm:ss"))
            if(errorBegin===true || errorFinal===true){
                this.setState({
                    error:true,
                    errorIndex:2
                })
            }else if(moment(newState['begin']).unix()==moment(newState['final']).unix()){
                this.setState({
                    error:true,
                    errorIndex:3
                })
            }else if(newState['objetivos'].length===0){
                this.setState({
                    error:true,
                    errorIndex:4
                })
            }else if(begin > final){
                this.setState({
                    error:true,
                    errorIndex: 5
                })
            }else{
                let token = sessionStorage.getItem('key')
                //const {comment, titulo, objetivos}=newState
                //var begin=(moment(dateRange.selection.startDate).format("YYYY-MM-DD")+' '+moment(newState['begin']).format("HH:mm:ss"))
                //var final=(moment(dateRange.selection.endDate).format("YYYY-MM-DD")+' '+moment(newState['final']).format("HH:mm:ss"))

                /* llamo para hacer el insert si responde sale guardar si no que hubo error*/
                getValidateMaintenance(user, token, begin, final, newObjetivos, 0).then(data=>{
                    if (data.length > 0){
                        this.setState({
                            loadModal: true,
                            check: false,
                            objError: data,
                            errorIndex: 6,
                            error:true,
                        })
                    } else {
                        createMaintenance(user, nameUser, token, begin, final, comment, titulo, newObjetivos).then(data=>{
                            if(data===false){
                                this.setState({
                                    loadModal: true,
                                    check: false
                                });
                            }else{
                                this.setState({
                                    loadModal: true,
                                    check: true
                                }); 
                            }
                            
                        })
                    }
                })
            }
        }
    }

    handleClose = event => {
        //const newStep = event.currentTarget.id
        if (this.state.check === true) {
            this.props.onInfo(0)
        }
        
        this.setState({
            loadModal: false,
        })
    };

    formatErrorDate = (dateString) => {
        const d = new Date(dateString);
        
        // Extraemos las partes y aseguramos los dos dígitos con padStart
        const yy = String(d.getFullYear());
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        
        const hh = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        const ss = String(d.getSeconds()).padStart(2, '0');
        
        return `${yy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    };

    // Seleccionar todos
    handleSelectAllObjectives = () => {
        const { listObjectives } = this.state;
        this.handleFieldChange('objetivos', listObjectives);
    };

    // Deseleccionar todos
    handleDeselectAllObjectives = () => {
        this.handleFieldChange('objetivos', []);
    };

    render() {
        const { classes, className, alertobjectives, t, ...rest } = this.props;
        const {dateRange, booleanDate,nameUser, listObjectives, errorBegin, errorFinal, errorIndex, errors,
                 error, loadModal, check, hourInitial, hourFinal, title, comment, objId, objError}=this.state
        return (
            <Portlet
            >
                <PortletHeader>
                    <PortletLabel
                        subtitle={t ? t('schedule.subtitle') : 'Ingrese mantenimiento'}
                        title={t ? t('schedule.title') : 'Agenda'}
                    />
                </PortletHeader>
                <PortletContent noPadding>
                    <form autoComplete="off" noValidate>
                        <Grid container style={{ padding: "20px 30px" }}>
                            
                            {/* Campo Nombre */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                                style={{ textAlign: "left" }}
                            >
                                <TextField
                                    //helperText="Nombre"
                                    label={t ? t('schedule.label.name') : 'Nombre'}
                                    margin="dense"
                                    onChange={event =>
                                        this.handleFieldChange('name', event.target.value)
                                    }
                                    required
                                    value={nameUser[0].toUpperCase() + nameUser.substring(1)}
                                    disabled id="standard-disabled"
                                    //variant="outlined"
                                />
                            </Grid>

                            {/* Estrutura de 2 columnas (50% / 50%) */}
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    
                                    {/* COLUMNA 1 (IZQUIERDA): DateRange centrado */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Typography style={{ marginBottom: '16px' }}>
                                            {t ? t('schedule.define_range') : 'Definir Rango de tiempo'}
                                        </Typography>
                                        <DateRange
                                            //maxDate={addDays(new Date(), 0)}
                                            minDate={addMonths(new Date(), -3)}
                                            locale={this.state.dateFnsLocale}
                                            key={'dr-' + this.state.localeKey}
                                            onChange={this.handleRangeChange.bind(this, 'dateRange')}
                                            moveRangeOnFirstSelection={false}
                                            ranges={[this.state.dateRange.selection]}
                                            className={'PreviewArea'}
                                        />
                                    </Grid>

                                    {/* COLUMNA 2 (DERECHA): Visible siempre pero deshabilitada si !booleanDate */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        style={{
                                            opacity: booleanDate ? 1 : 0.5,
                                            transition: 'opacity 0.3s ease'
                                        }}
                                    >
                                        <Grid
                                            container
                                            spacing={1}
                                            style={{ textAlign: "left" }}
                                        >
                                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                                    <TextField
                                                        disabled={!booleanDate}
                                                        label={t ? t('schedule.label.hour_start') : 'hora inicio'}
                                                        margin="dense"
                                                        required
                                                        onChange={event =>
                                                            this.handleFieldChange('begin', event.target.value)
                                                        }
                                                        placeholder="00:00:00"
                                                        defaultValue={hourInitial}
                                                        type="time"
                                                        inputProps={{ step: 1 }}
                                                        inputRef={el => this.startTimeInputRef = el}
                                                        onClick={() => {
                                                            if (booleanDate && this.startTimeInputRef && typeof this.startTimeInputRef.showPicker === 'function') {
                                                                this.startTimeInputRef.showPicker();
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                {errorBegin ? (
                                                    <Grid item xs={12} sm={12} md={12} xl={12}>
                                                        <Typography variant="caption" color="primary">{t ? t('schedule.errors.bad_date_format') : 'error de formato fecha'}</Typography>
                                                    </Grid>
                                                ) : null}
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                                    <TextField
                                                        disabled={!booleanDate}
                                                        label={t ? t('schedule.label.hour_end') : 'hora termino'}
                                                        margin="dense"
                                                        required
                                                        onChange={event =>
                                                            this.handleFieldChange('final', event.target.value)
                                                        }
                                                        placeholder="23:59:00"
                                                        defaultValue={hourFinal}
                                                        type="time"
                                                        inputProps={{ step: 1 }}
                                                        inputRef={el => this.endTimeInputRef = el}
                                                        onClick={() => {
                                                            if (booleanDate && this.endTimeInputRef && typeof this.endTimeInputRef.showPicker === 'function') {
                                                                this.endTimeInputRef.showPicker();
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                {errorFinal ? (
                                                    <Grid item xs={12} sm={12} md={12} xl={12}>
                                                        <Typography variant="caption" color="primary">{t ? t('schedule.errors.bad_date_format') : 'error de formato fecha'}</Typography>
                                                    </Grid>
                                                ) : null}
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                                <TextField
                                                    disabled={!booleanDate}
                                                    label={t ? t('schedule.label.title') : 'titulo'}
                                                    margin="dense"
                                                    required
                                                    onChange={event =>
                                                        this.handleFieldChange('titulo', event.target.value)
                                                    }
                                                    defaultValue={title}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                                <TextField
                                                    disabled={!booleanDate}
                                                    style={{ width: "75%" }}
                                                    id="standard-multiline-static"
                                                    label={t ? t('schedule.label.comment') : 'comentario'}
                                                    onChange={event =>
                                                        this.handleFieldChange('comment', event.target.value)
                                                    }
                                                    multiline
                                                    required
                                                    rows={4}
                                                    defaultValue={comment}
                                                />
                                            </Grid>

                                            {/* Sección Autocomplete + Acciones Masivas */}
                                            <Grid item xs={12} style={{ marginTop: '16px' }}>
                                                <Paper
                                                    variant="outlined"
                                                    style={{
                                                        padding: '16px',
                                                        backgroundColor: '#f9fafb',
                                                        borderColor: objError && objError.length > 0 ? '#f44336' : '#e0e0e0'
                                                    }}
                                                >
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="left"
                                                        mb={1.5}
                                                    >
                                                        <Box display="flex" gap={2}>
                                                            <Button
                                                                disabled={!booleanDate}
                                                                size="small"
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={() => this.handleSelectAllObjectives(listObjectives)}
                                                                style={{ marginRight: '16px' }}
                                                            >
                                                                {t ? t('schedule.button.select_all') : 'Agregar todos'}
                                                            </Button>
                                                            <Button
                                                                disabled={!booleanDate}
                                                                size="small"
                                                                variant="outlined"
                                                                color="inherit"
                                                                onClick={this.handleDeselectAllObjectives}
                                                                style={{
                                                                    color: 'rgba(0, 0, 0, 0.54)',
                                                                    borderColor: 'rgba(0, 0, 0, 0.23)'
                                                                }}
                                                            >
                                                                {t ? t('schedule.button.deselect_all') : 'Quitar todos'}
                                                            </Button>
                                                        </Box>
                                                    </Box>

                                                    <Autocomplete
                                                        disabled={!booleanDate}
                                                        multiple
                                                        value={this.state.newState?.objetivos || objId || []}
                                                        options={listObjectives || []}
                                                        getOptionLabel={option => option.nombre}
                                                        isOptionEqualToValue={(option, value) => option.objetivo_id === value.objetivo_id}
                                                        onChange={(event, newValue) => this.handleFieldChange('objetivos', newValue)}
                                                        style={{ width: '100%' }}
                                                        classes={{
                                                            endAdornment: classes.autocompleteEndAdornment
                                                        }}
                                                        renderTags={(tagValue, getTagProps) => (
                                                            <div className={classes.tagsContainer}>
                                                                {tagValue.map((option, index) => {
                                                                    const errorDetail = objError?.find(err => err.objetivo_id === option.objetivo_id);
                                                                    const hasError = Boolean(errorDetail);

                                                                    const chip = (
                                                                        <Chip
                                                                            label={option.nombre}
                                                                            {...getTagProps({ index })}
                                                                            style={{
                                                                                backgroundColor: hasError ? '#ed9987' : '#b1d1fa',
                                                                                color: 'white',
                                                                                fontWeight: 500,
                                                                                border: 'none',
                                                                                boxShadow: hasError ? '0px 2px 4px rgba(211, 47, 47, 0.4)' : 'none',
                                                                                margin: '2px'
                                                                            }}
                                                                        />
                                                                    );

                                                                    if (hasError) {
                                                                        const inicioFormateado = this.formatErrorDate(errorDetail.fecha_inicio);
                                                                        const terminoFormateado = this.formatErrorDate(errorDetail.fecha_termino);
                                                                        const tooltipMessage = 'schedule.autocomplete.tooltip_type_' + errorDetail.id_tipo_marcado;
                                                                        return (
                                                                            <Tooltip
                                                                                key={option.objetivo_id}
                                                                                title={
                                                                                    t
                                                                                        ? `${t(tooltipMessage)} ${inicioFormateado} ${t('schedule.autocomplete.tooltip_to')} ${terminoFormateado}`
                                                                                        : `Tiene un mantenimiento agendado: ${inicioFormateado} Hasta ${terminoFormateado}`
                                                                                }
                                                                                arrow
                                                                                placement="top"
                                                                            >
                                                                                <span style={{ display: 'inline-flex' }}>{chip}</span>
                                                                            </Tooltip>
                                                                        );
                                                                    }

                                                                    return (
                                                                        <React.Fragment key={option.objetivo_id}>
                                                                            {chip}
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                        renderInput={params => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                label={t ? t('schedule.autocomplete.label') : 'Selecciona Objetivos'}
                                                                placeholder={t ? t('schedule.autocomplete.placeholder') : 'Objetivos'}
                                                                fullWidth
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    className: `${params.InputProps.className} ${classes.autocompleteInputRoot}`
                                                                }}
                                                                inputProps={{
                                                                    ...params.inputProps,
                                                                    style: {
                                                                        ...params.inputProps.style,
                                                                        width: '100%'
                                                                    }
                                                                }}
                                                                helperText={
                                                                    (objError && objError.length > 0)
                                                                        ? (t ? t('schedule.autocomplete.error') : 'Algunos objetivos seleccionados tienen conflictos de horario (en rojo).')
                                                                        : ""
                                                                }
                                                                error={objError && objError.length > 0}
                                                            />
                                                        )}
                                                    />
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>

                            {/* Notificaciones */}
                            <Snackbar
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                open={loadModal}
                                autoHideDuration={5000}
                                onClose={this.handleClose}
                            >
                                {check ? (
                                    <Alert
                                        onClose={this.handleClose}
                                        severity="success"
                                        variant="filled"
                                        sx={{ width: '100%' }}
                                    >
                                        {t ? t('schedule.modal.success') : 'Mantenimiento ingresado con exito'}
                                    </Alert>
                                ) : (
                                    <Alert
                                        onClose={this.handleClose}
                                        severity="error"
                                        variant="filled"
                                        sx={{ width: '100%' }}
                                    >
                                        {t ? t('schedule.modal.error') : 'Ha ocurrido un error, intente nuevamente'}
                                    </Alert>
                                )}
                            </Snackbar>
                        </Grid>
                    </form>
                </PortletContent>
                <PortletFooter align="right">
                    {error && (
                        <Box sx={{ width: '100%', mb: 1 }}> {/* mb: 1 añade un pequeño margen abajo */}
                            <Typography variant="caption" color="error">
                                {t ? t(errors[errorIndex]) : ''}
                            </Typography>
                        </Box>
                    )}

                    <Button
                        onClick={this.handleSaved}
                        color="primary"
                        variant="contained"
                        disabled={!booleanDate}
                    >
                        {t ? t('schedule.button.save') : 'Guardar Mantenimiento'}
                    </Button>
                </PortletFooter>
            </Portlet>
            
        );
    }
}


export default compose(withWidth(), withStyles(styles), withTranslation())(Schedule);